// MainLayout.jsx
import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { HiHome, HiStar } from 'react-icons/hi2';
import { HiBuildingStorefront, HiUser, HiPlus } from 'react-icons/hi2';

const TABS = [
  { name: 'index', path: '/app/home', label: 'Home', Icon: HiHome },
  { name: 'garages', path: '/app/garages', label: 'Garages', Icon: HiBuildingStorefront },
  { name: 'favorites', path: '/app/favorites', label: 'Favorites', Icon: HiStar },
  { name: 'account', path: '/app/account', label: 'Account', Icon: HiUser },
];

function TabButton({ tab, isActive, onPress }) {
  return (
    <button
      onClick={() => onPress(tab.path)}
      className={`flex flex-col items-center justify-center gap-1 bg-transparent border-none cursor-pointer p-0 min-w-[52px] transition-colors duration-150 ${
        isActive ? 'text-[#111111]' : 'text-zinc-400'
      }`}
    >
      <tab.Icon size={20} />
      <span className="text-[11px] font-semibold">{tab.label}</span>
    </button>
  );
}

function TabBar({ onCreatePress }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <div className="fixed bottom-6 left-5 right-5 flex justify-center pointer-events-none z-50">
      <div className="flex flex-row items-center justify-between bg-white rounded-[28px] px-[22px] py-[14px] w-full max-w-[480px] shadow-[0_10px_40px_rgba(0,0,0,0.10)] pointer-events-auto">
        {/* Home */}
        <TabButton tab={TABS[0]} isActive={pathname === TABS[0].path} onPress={navigate} />

        {/* Garages + Plus + Favorites */}
        <div className="flex flex-row items-center">
          <TabButton tab={TABS[1]} isActive={pathname === TABS[1].path} onPress={navigate} />

          <button
            onClick={onCreatePress}
            aria-label="Create post"
            className="w-[54px] h-[54px] rounded-full bg-[#111111] border-none cursor-pointer flex items-center justify-center mx-[18px] -mt-[34px] flex-shrink-0 transition-opacity duration-150 hover:opacity-80 active:scale-95"
          >
            <HiPlus size={22} color="#ffffff" />
          </button>

          <TabButton tab={TABS[2]} isActive={pathname === TABS[2].path} onPress={navigate} />
        </div>

        {/* Account */}
        <TabButton tab={TABS[3]} isActive={pathname === TABS[3].path} onPress={navigate} />
      </div>
    </div>
  );
}

export const MainLayout = ({ title, description, children }) => {
  const navigate = useNavigate();

  const handleCreatePress = () => navigate('/app/home/create-post');

  return (
    <>
      <main className="pb-[120px]">{children}</main>

      <TabBar onCreatePress={handleCreatePress} />
    </>
  );
};
